import classes from './style.module.scss';
import MenuItem from '../MenuItem/MenuItem';
import ScrollButton from '../ScrollButton/ScrollButton';
import React from 'react';
import Footer from '../Footer/Footer';

const Menu = () => {
    const foodList = [
        {
            name: 'Завтрак',
            positions: [
                {
                    name: 'Бутерброд с ветчиной и сыром',
                    composition:
                        'Хлеб белый, масло сливочное, сыр, ветчина из индейки',
                    price: '80гр. - 150 руб.',
                },
                {
                    name: 'Блины',
                    composition: 'Блинчики по домашнему со сметаной или джемом',
                    price: '150/40гр. - 200 руб.',
                },
                {
                    name: 'Яичница-глазунья',
                    composition: 'Яичница-глазунья по-домашнему из трёх яиц',
                    price: '160гр. - 250 руб.',
                },
                {
                    name: 'Омлет',
                    composition: 'Яйцо куриное, молоко, соль, сахар',
                    price: '200гр. - 300 руб.',
                },
                {
                    name: 'Каша в ассортименте',
                    composition:
                        'Манная или овсяная каша на воде или молоке со сливочным маслом',
                    price: '300/50гр. - 250 руб.',
                },
                {
                    name: 'Сырники',
                    composition: 'Сырники по-домашнему со сметаной или джемом',
                    price: '150/40гр. - 300 руб.',
                },
            ],
        },
        {
            name: 'Салаты',
            positions: [
                {
                    name: 'Овощной салат',
                    composition:
                        'Огурцы, помидоры, капуста, болгарский перец, красный лук, листья салата, зелень, заправка на выбор (масло растительное, сметана или майонез)',
                    price: '230гр. - 280 руб.',
                },
                {
                    name: 'Греческий салат',
                    composition:
                        'Огурцы, помидоры, сыр фета, красный лук, маслины',
                    price: '260гр. - 350 руб.',
                },
                {
                    name: 'Цезарь с курицей',
                    composition:
                        'Айсберг, куриное филе, заправка Цезарь, пармезан, сухарики',
                    price: '210гр. - 400 руб.',
                },
                {
                    name: 'Цезарь с креветками',
                    composition:
                        'Айсберг, креветки, заправка Цезарь, пармезан, сухарики',
                    price: '210гр. - 650 руб.',
                },
            ],
        },
        {
            name: 'Холодные закуски',
            positions: [
                {
                    name: 'Овощная нарезка',
                    composition:
                        'Огурцы, помидоры, болгарский перец, редис, зелень',
                    price: '300гр. - 380 руб.',
                },
                {
                    name: 'Ассорти солений',
                    composition:
                        'Маринованные огурцы, помидоры, квашеная капуста',
                    price: '300гр. - 300 руб.',
                },
                {
                    name: 'Селёдка с картошкой',
                    composition: 'Картофель, сельдь маринованая, лук',
                    price: '300гр. - 400 руб.',
                },
                {
                    name: 'Мясное ассорти',
                    composition: 'Карбонад, грудинка, сырокопчёная колбаса',
                    price: '150гр. - 650 руб.',
                },
            ],
        },
        {
            name: 'Горячие закуски',
            positions: [
                {
                    name: 'Картофель фри',
                    composition: 'Картофель фри с соусом на выбор',
                    price: '150/40гр. - 250 руб.',
                },
                {
                    name: 'Картофель по-деревенски',
                    composition: 'Картофель по-деревенски с соусом на выбор',
                    price: '150/40гр. - 250 руб.',
                },
                {
                    name: 'Наггетсы',
                    composition: 'Наггетсы с соусом на выбор',
                    price: '150/40гр. - 250 руб.',
                },
                {
                    name: 'Гренки с чесночным соусом',
                    price: '200/40гр. - 250 руб.',
                },
                {
                    name: 'Луковые кольца',
                    composition: 'Луковые кольца с соусом на выбор',
                    price: '150/40гр. - 250 руб.',
                },
                {
                    name: 'Пельмени жареные',
                    composition:
                        'Домашние пельмени из курицы, говядины или индейки с соусом на выбор',
                    price: '200/40гр. - 400 руб.',
                },
                {
                    name: 'Куриные крылья с соусом BBQ',
                    price: '300/40гр. - 400 руб.',
                },
                {
                    name: 'Клаб-сэндвич с ветчиной',
                    composition:
                        'Тостовый хлеб, ветчина из индейки, помидор, маринованный огурец, лист салата, сыр,  соус',
                    price: '270гр. - 400 руб.',
                },
                {
                    name: 'Клаб-сэндвич с курицей',
                    composition:
                        'Тостовый хлеб, куриное филе, помидор, маринованный огурец, лист салата, сыр,  соус',
                    price: '270гр. - 450 руб.',
                },
                {
                    name: 'Кесадилья куриная  с соусом тартар',
                    composition:
                        'Куриное филе, перец болгарский, лук репчатый, помидоры, мексиканские специи, сыр моцарелла, пшеничная лепешка тортилья, соус тартар',
                    price: '330/40гр. - 550 руб.',
                },
                {
                    name: 'Сырные палочки с кисло-сладким соусом',
                    price: '150/40гр. - 450 руб.',
                },
            ],
        },
        {
            name: 'Супы',
            positions: [
                {
                    name: 'Куриный суп',
                    composition:
                        'Куриное мясо, вермишель, картофель, морковь, лук',
                    price: '350гр. - 250 руб.',
                },
                {
                    name: 'Борщ со сметаной',
                    composition:
                        'Борщ из говядины, подается со сметаной, чесноком и черным хлебом',
                    price: '350гр. - 350 руб.',
                },
                {
                    name: 'Харчо',
                    price: '350гр. - 350 руб.',
                },
                {
                    name: 'Окрошка на кефире',
                    composition:
                        'Картофель, ветчина из индейки, огурцы, редис, яйца, зелень',
                    price: '350гр. - 350 руб.',
                },
            ],
        },
        {
            name: 'Горячие блюда',
            positions: [
                {
                    name: 'Котлета',
                    composition:
                        'Домашние котлеты из курицы, говядины или индейки',
                    price: '125гр. - 200 руб.',
                },
                {
                    name: 'Шницель куриный',
                    composition:
                        'Филе куриное, сырная панировка, кисло-сладкий соус',
                    price: '200гр. - 250 руб.',
                },
                {
                    name: 'Куриное филе запечённое с помидором и сыром',
                    composition: 'Филе куриное, помидор, сыр',
                    price: '200гр. - 350 руб.',
                },
                {
                    name: 'Вареники с картофелем и грибами со сметаной',
                    price: '300/40гр. - 300 руб.',
                },
                {
                    name: 'Вареники с творогом со сметаной',
                    price: '300/40гр. - 350 руб.',
                },
                {
                    name: 'Обжареные вареники с картофелем и грибами со сметаной',
                    composition:
                        'Обжареные домашние вареники с картофелем и грибами на сливочном масле, сметана',
                    price: '300/40гр. - 350 руб.',
                },
                {
                    name: 'Обжареные вареники с творогом со сметаной',
                    composition:
                        'Обжареные домашние вареники с творогом на сливочном масле, сметана',
                    price: '300/40гр. - 400 руб.',
                },
                {
                    name: 'Пельмени со сметаной',
                    composition:
                        'Домашние пельмени из курицы, говядины или индейки, сметана',
                    price: '300/40гр. - 400 руб.',
                },
                {
                    name: 'Паста с курицей и грибами',
                    composition:
                        'Паста, курица, шампиньоны, чеснок, помидор, сливки, пармезан',
                    price: '350гр. - 450 руб.',
                },
                {
                    name: 'Паста карбонара',
                    composition: 'Паста, бекон, шампиньоны, сливки, пармезан',
                    price: '350гр. - 450 руб.',
                },
                {
                    name: 'Колбаски с квашеной капустой',
                    composition:
                        'Колбаски из курицы, говядины или индейки, квашеная капуста',
                    price: '200/100гр. - 450 руб.',
                },
                {
                    name: 'Чахохбили',
                    composition: 'Курица, томаты, чеснок, зелень, специи',
                    price: '250гр. - 450 руб.',
                },
                {
                    name: 'Фрикасе из курицы в сливочном соусе ',
                    composition:
                        'Куриное филе, шампиньоны, сливки, мука, гречка или рис на выбор',
                    price: '150/150гр. - 450 руб.',
                },
                {
                    name: 'Хачапури по-мергрельски',
                    composition:
                        'Лепешка из теста с щедрой порцией сыра сулугуни внутри и снаружи',
                    price: '400гр. - 450 руб.',
                },
                {
                    name: 'Хачапури по-аджарски',
                    composition:
                        'Тесто в форме лодочки, с большим количеством сыра сулугуни, яйцо',
                    price: '430гр. - 500 руб.',
                },
            ],
        },
        {
            name: 'Гарниры',
            positions: [
                {
                    name: 'Гречка с грибами и луком',
                    composition: 'Гречка, шампиньоны, лук',
                    price: '200гр. - 200 руб.',
                },
                {
                    name: 'Рис с овощами',
                    composition: 'Рис, лук, болгарский перец, морковь',
                    price: '200гр. - 200 руб.',
                },
                {
                    name: 'Паста спагетти ,масло сливочное, зелень',
                    price: '200гр. - 200 руб.',
                },
                {
                    name: 'Картофельное пюре',
                    composition: 'Картофель, молоко, сливочное масло',
                    price: '200гр. - 200 руб.',
                },
            ],
        },
        {
            name: 'Топпинги',
            positions: [
                {
                    name: 'Соусы на выбор',
                    price: '40гр. - 70 руб.',
                },
                {
                    name: 'Сметана',
                    price: '40гр. - 70 руб.',
                },
                {
                    name: 'Джем',
                    price: '40гр. - 70 руб.',
                },
                {
                    name: 'Сгущеное молоко',
                    price: '40гр. - 70 руб.',
                },
                {
                    name: 'Грибы шампиньоны',
                    price: '100 руб.',
                },
                {
                    name: 'Сыр',
                    price: '100 руб.',
                },
                {
                    name: 'Помидоры',
                    price: '100 руб.',
                },
                {
                    name: 'Ветчина из индейки',
                    price: '100 руб.',
                },
            ],
        },
        {
            name: 'Комплексные обеды',
            positions: [
                {
                    name: 'Комплексный обед №1',
                    composition: 'салат или морс (домашний лимонад) + второе',
                    price: '350 руб.',
                },
                {
                    name: 'Комплексный обед №2',
                    composition: 'первое + второе',
                    price: '400 руб.',
                },
                {
                    name: 'Комплексный обед №3',
                    composition:
                        'салат + первое + второе + морс (домашний лимонад)',
                    price: '450 руб.',
                },
            ],
        },
    ];
    const barList = [
        {
            name: 'Чай',
            positions: [
                {
                    name: 'Чай черный, зеленый, красный, травяной',
                    price: '0,4л. - 250 руб.',
                },
                {
                    name: 'Черный с облепихой',
                    price: '1л. - 600 руб.',
                },
                {
                    name: 'Зеленый с имбирем',
                    price: '1л. - 600 руб.',
                },
                {
                    name: 'Красный с апельсином',
                    price: '1л. - 600 руб.',
                },
                {
                    name: 'Клубничный чай',
                    price: '1л. - 500 руб.',
                },
                {
                    name: 'Мохито чай',
                    price: '1л. - 500 руб.',
                },
                {
                    name: 'Лесной чай',
                    price: '1л. - 500 руб.',
                },
                {
                    name: 'Рождественский чай',
                    price: '1л. - 500 руб.',
                },
                {
                    name: 'Новогодний чай',
                    price: '1л. - 500 руб.',
                },
            ],
        },
        {
            name: 'Кофе',
            positions: [
                {
                    name: 'Эспрессо',
                    price: '0,1л. - 150 руб.',
                },
                {
                    name: 'Американо',
                    price: '0,15л. - 180 руб.',
                },
                {
                    name: 'Капучино',
                    price: '0,25л. - 250 руб.',
                },
                {
                    name: 'Латте',
                    price: '0,25л. - 250 руб.',
                },
            ],
        },
        {
            name: 'Добавки',
            positions: [
                {
                    name: 'Мята',
                    price: '50 руб.',
                },
                {
                    name: 'Мелисса',
                    price: '50 руб.',
                },
                {
                    name: 'Чабрец',
                    price: '50 руб.',
                },
                {
                    name: 'Лимон',
                    price: '50 руб.',
                },
                {
                    name: 'Лист смородины',
                    price: '50 руб.',
                },
                {
                    name: 'Сироп в ассортименте',
                    price: '30 руб.',
                },
                {
                    name: 'Молоко',
                    price: '50мл. - 50 руб.',
                },
                {
                    name: 'Сливки',
                    price: '30мл. - 50 руб.',
                },
            ],
        },
        {
            name: 'Снэки',
            positions: [
                {
                    name: 'Пирожное Чоко-пай',
                    price: '1шт. - 70 руб.',
                },
                {
                    name: 'Круассаны мини',
                    price: '70гр. - 200 руб.',
                },
                {
                    name: 'Арахис жареный',
                    price: '100гр. - 200 руб.',
                },
                {
                    name: 'Сухарики Хрустим',
                    price: '60гр. - 200 руб.',
                },
                {
                    name: 'Фисташки',
                    price: '50гр. - 250 руб.',
                },
                {
                    name: 'Чипсы Лэйс',
                    price: '70гр. - 250 руб.',
                },
                {
                    name: 'Шоколад в ассортименте',
                    price: '1шт. - 300 руб.',
                },
                {
                    name: 'Шоколад Риттер Спорт',
                    price: '1шт. - 350 руб.',
                },
                {
                    name: 'Колбаски сырокопченые',
                    price: '70гр. - 350 руб.',
                },
                {
                    name: 'Сыр чечилл',
                    price: '100гр. - 400 руб.',
                },
            ],
        },
        {
            name: 'Безалкогольные напитки',
            positions: [
                {
                    name: 'Лимонад Легендарный',
                    price: '1л. - 350 руб.',
                },
                {
                    name: 'Морс Легендарный',
                    price: '1л. - 350 руб.',
                },
                {
                    name: 'Аква Минерале',
                    price: '0,5л. - 150 руб.',
                },
                {
                    name: 'Эвервесс в ассорименте',
                    price: '0,33л. - 200 руб.',
                },
                {
                    name: 'Пепси',
                    price: '0,25л. - 200 руб.',
                },
                {
                    name: 'Липтон',
                    price: '0,25л. - 200 руб.',
                },
                {
                    name: 'Газированная вода в ассортименте',
                    price: '0,5л. - 250 руб.',
                },
                {
                    name: 'Минеральная вода Рычал-Су',
                    price: '0,5л. - 250 руб.',
                },
                {
                    name: 'Адреналин Раш',
                    price: '0,449л. - 300 руб.',
                },
            ],
        },
        {
            name: 'Пиво, сидр',
            positions: [
                {
                    name: 'Пиво Бад',
                    price: '0,44л. - 250 руб.',
                },
                {
                    name: 'Пиво Козел',
                    price: '0,44л. - 250 руб.',
                },
                {
                    name: 'Пиво Грин Бит',
                    price: '0,45л. - 250 руб.',
                },
                {
                    name: 'Пиво Аббе',
                    price: '0,33л. - 250 руб.',
                },
                {
                    name: 'Пиво Стелла Артуа',
                    price: '0,44л. - 300 руб.',
                },
                {
                    name: 'Пиво Хугарден',
                    price: '0,47л. - 300 руб.',
                },
                {
                    name: 'Пиво Клаусталер безалкогольное',
                    price: '0,33л. - 400 руб.',
                },
                {
                    name: 'Пиво Францискайнер',
                    price: '0,45л. - 450 руб.',
                },
                {
                    name: 'Пиво Корона Экстра',
                    price: '0,355л. - 500 руб.',
                },
                {
                    name: 'Эль Доктор Фауст',
                    price: '0,75л. - 550 руб.',
                },
                {
                    name: 'Крепкий тёмный эль "Синяя борода"',
                    price: '0,75л. - 550 руб.',
                },
                {
                    name: 'Тройной Пшеничный эль',
                    price: '0,75л. - 550 руб.',
                },
                {
                    name: 'Вишневый эль Чехов',
                    price: '0,75л. - 550 руб.',
                },
                {
                    name: 'Сидр в ассортименте',
                    price: '0,75л. - 550 руб.',
                },
            ],
        },
        {
            name: 'Разливное пиво',
            positions: [
                {
                    name: 'Разливное пиво Амбервайс',
                    price: '0,5л. - 250 руб.',
                },
                {
                    name: 'Разливное пиво Эфес Пилснер',
                    price: '0,5л. - 300 руб.',
                },
                {
                    name: 'Разливное пиво Шпатен',
                    price: '0,5л. - 450 руб.',
                },
            ],
        },
    ];
    const kitchenSchedule = [
        'Понедельник - 12:00-22:00',
        'Вторник - 12:00-22:00',
        'Среда - 12:00-22:00',
        'Четверг - 12:00-22:00',
        'Пятница - 12:00-22:00',
        'Суббота - 12:00-22:00',
        'Воскресенье - 12:00-22:00',
    ];

    const getScroll = (id) => {
        window.location.hash = id;
    };

    return (
        <div className={classes.backgroundContainer}>
            <div className={classes.container}>
                <h2 className={classes.title}>Меню ресторана</h2>
                <div className={classes.menuNavigation}>
                    <div>
                        <h3>Кухня</h3>
                        <div className={classes.schedule}>
                            {kitchenSchedule.map((item, index) => (
                                <p key={index}>{item}</p>
                            ))}
                        </div>
                        <div className={classes.menuButtons}>
                            {foodList.map((item, index) => (
                                <button
                                    onClick={() => getScroll(item.name)}
                                    key={index}
                                >
                                    {item.name}
                                </button>
                            ))}
                        </div>
                    </div>
                    <div>
                        <h3>Бар</h3>
                        <div className={classes.schedule}>
                            <p>Каждый день - всё время работы клуба</p>
                        </div>
                        <div className={classes.menuButtons}>
                            {barList.map((item, index) => (
                                <button
                                    onClick={() => getScroll(item.name)}
                                    key={index}
                                >
                                    {item.name}
                                </button>
                            ))}
                        </div>
                    </div>
                </div>
                <div className={classes.menu}>
                    <div className={classes.foodMenu}>
                        <div>
                            {foodList.map((item, index) => (
                                <div
                                    id={item.name}
                                    key={index}
                                    className={classes.menuItem}
                                >
                                    <h2>{item.name}</h2>
                                    <div>
                                        {item.positions.map((item, index) => (
                                            <MenuItem
                                                key={index}
                                                name={item.name}
                                                composition={item.composition}
                                                price={item.price}
                                            />
                                        ))}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className={classes.barMenu}>
                        <div>
                            {barList.map((item, index) => (
                                <div
                                    id={item.name}
                                    key={index}
                                    className={classes.menuItem}
                                >
                                    <h2>{item.name}</h2>
                                    <div>
                                        {item.positions.map((item, index) => (
                                            <MenuItem
                                                key={index}
                                                name={item.name}
                                                composition={item.composition}
                                                price={item.price}
                                            />
                                        ))}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
            <ScrollButton />
            <Footer className={classes.transparentContainer} />
        </div>
    );
};

export default Menu;
